import { createSubmitter, createUploader } from './api'

export type BugSeverity = 'low' | 'medium' | 'high' | 'critical'

export type BugAttachment = {
  /** Opaque handle minted by the backend. The ticket URL is derived from it server-side. */
  id: string
  filename: string
  content_type: string
  size_bytes: number
  url: string
}

export type BugReportRequest = {
  title: string
  description: string
  severity?: BugSeverity
  area?: string
  steps_to_reproduce?: string
  url?: string
  user_agent?: string
  attachment_ids?: string[]
}

export type BugReportResponse = {
  ticket_id: string
  ticket_number: number
  ticket_url: string
}

export const bugReportService = {
  /** File a bug into the Featurebase Bug tracker (EnGen staff only; Clerk-authed). */
  async submitBug(data: BugReportRequest, getToken: () => Promise<string | null>): Promise<BugReportResponse> {
    const submitter = createSubmitter(getToken)
    return await submitter('/integrations/support/bug', data)
  },

  /** Upload one attachment up front and get back the id the report cites it by. */
  async uploadAttachment(file: File, getToken: () => Promise<string | null>): Promise<BugAttachment> {
    const body = new FormData()
    body.append('file', file)
    const uploader = createUploader(getToken)
    return await uploader('/integrations/support/attachments', body)
  },
}
